export const ADD_TYPING_TIMEOUT_ID = 'ADD_TYPING_TIMEOUT_ID';
export const REMOVE_TYPING_TIMEOUT_ID = 'REMOVE_TYPING_TIMEOUT_ID';